<div class="layout-container" *ngIf="attachments$">
  <div class="flex flex-col" *ngFor=" let doc of attachments$ | async">
    <div class="flex flex-row justify-start items-center">
      <mat-icon (click)="selectRow(doc)">info</mat-icon>
      <a data-cy="attachment-link" (click)="download(doc)">{{doc.contentName}}</a>
    </div>
  </div>
</div>

